import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { Megaphone, Warning, Info } from '@phosphor-icons/react';

export default function Announcements() {
  const { data: items } = useQuery({ queryKey: ['broadcast-history'], queryFn: () => api.get('/broadcasts/history').then((r) => r.data) });

  return (
    <div data-testid="announcements-page">
      <div className="mb-6">
        <p className="font-mono-label text-[10px] uppercase text-slate-400 mb-1">Every banner you've received - even after dismissing</p>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight flex items-center gap-2"><Megaphone size={30} className="text-orange-600" weight="duotone" /> Announcements</h1>
      </div>
      <div className="space-y-3 max-w-3xl">
        {(items || []).map((b) => (
          <div key={b.id} data-testid={`announcement-${b.id}`} className={`bg-white border rounded-lg p-4 stagger-in ${b.expired ? 'border-slate-200 opacity-70' : b.level === 'urgent' ? 'border-rose-200' : 'border-orange-200'}`}>
            <div className="flex items-start gap-3">
              {b.level === 'urgent'
                ? <Warning size={20} weight="fill" className={`shrink-0 mt-0.5 ${b.expired ? 'text-slate-400' : 'text-rose-600'}`} />
                : <Info size={20} weight="fill" className={`shrink-0 mt-0.5 ${b.expired ? 'text-slate-400' : 'text-orange-500'}`} />}
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <p className="font-display font-bold">{b.title}</p>
                  {b.expired && <span className="font-mono-label text-[8px] uppercase px-1.5 py-0.5 rounded bg-slate-100 text-slate-500">expired</span>}
                  {!b.expired && b.dismissed && <span className="font-mono-label text-[8px] uppercase px-1.5 py-0.5 rounded bg-slate-100 text-slate-500">dismissed</span>}
                  {!b.expired && !b.dismissed && <span className="font-mono-label text-[8px] uppercase px-1.5 py-0.5 rounded bg-green-100 text-green-700">active</span>}
                </div>
                <p className="text-sm text-slate-600 mt-0.5">{b.body}</p>
                <p className="text-[10px] text-slate-400 mt-1">{b.starts_at?.slice(0, 16).replace('T', ' ')}</p>
              </div>
            </div>
          </div>
        ))}
        {(items || []).length === 0 && (
          <div className="bg-white border border-slate-200 rounded-lg p-10 text-center text-slate-400" data-testid="announcements-empty">
            No announcements yet - school-wide banners will appear here.
          </div>
        )}
      </div>
    </div>
  );
}
